// resources/js/helpers/RoutesToModalId.js
import { route } from 'ziggy-js';

const modalRouteMapping = {
    // Path must end with trailing slash, but ziggy removes it...
    [route('signIn', undefined, false)]: 'login',
    [route('createAccount', undefined, false)]: 'register',
    [route('resetPassword', undefined, false)]: 'reset-password',
    [route('my.changePassword', undefined, false)]: 'change-password',
};

export function getModalIdByPath(pathname) {
    return modalRouteMapping[pathname] || null;
}
